import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@app/core/services/common.service';
import { ViewEncapsulation } from '@angular/core';
import { ReplaySubject, Subscription, takeUntil } from 'rxjs';
import { UserService } from '../../../core/services/user.service';
import { DOCUMENT, formatDate } from '@angular/common';
import { DOWNLOADAPP } from '@app/core';

@Component({
  selector: 'app-article-detail',
  templateUrl: './article-detail.component.html',
  styleUrls: ['./article-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ArticleDetailComponent implements OnInit, OnDestroy {
  protected destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  articleDetail: any = null;
  currentUrl: string = '';
  sport: string = ''; // Add a variable for sport

  constructor(
    private _activated: ActivatedRoute,
    private _router: Router,
    private _common: CommonService,
    private _user: UserService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    // Capture the current URL
    this.currentUrl = window.location.href;

    // Extract the sport from the URL
    this.sport = this._activated.snapshot.url[0]?.path || 'unknown'; // Assuming sport is the first path segment


    // Determine the device type
    const isMobile = this.isMobileDevice();

    // Create the button using image with appropriate src and URL
    let downloadAppButton = this.document.createElement('a');
    if (isMobile) {
      downloadAppButton.setAttribute('href', DOWNLOADAPP);
      const img = this.document.createElement('img');
      img.setAttribute('src', '/assets/img/button-7.png'); // Use relative path for assets
      img.setAttribute('alt', 'Download App for Predictions');
      downloadAppButton.appendChild(img);
    } else {
      downloadAppButton.onclick = () => this._user.makePayment();
      const img = this.document.createElement('img');
      img.setAttribute('src', '/assets/img/button-6.png'); // Use relative path for assets
      img.setAttribute('alt', 'Download App for Predictions');
      downloadAppButton.appendChild(img);
    }

    this._common.showsports.next(false);

    this._activated.paramMap.pipe(takeUntil(this.destroyed$)).subscribe(async (data) => {
      if (data.get('slug')) {
        let res = await this._common.getArticleDetail(data.get('slug'));
        this.articleDetail = res.data;
        this.articleDetail.topusers = res.topusers;

        // Set metadata
        this.setMetadata();

        setTimeout(() => {
          let divs = this.document.getElementsByClassName('prediction');
          if (divs.length) {
            this._user.subscribed.pipe(takeUntil(this.destroyed$)).subscribe((subscribed) => {
              for (let index = 0; index < divs.length; index++) {
                const element = divs.item(index);
                if (!subscribed) {
                  // If not subscribed, show download app button
                  element?.parentNode?.insertBefore(downloadAppButton, element.nextSibling);
                  element?.classList.add('d-none');
                } else {
                  // If subscribed, show text instead
                  element?.classList.remove('d-none');
                  const textNode = this.document.createTextNode('You are subscribed. Enjoy your predictions!');
                  element?.parentNode?.insertBefore(textNode, element.nextSibling);
                  downloadAppButton.remove();
                }
              }
            });
          }
        }, 500);

        return;
      }
      return this._router.navigateByUrl('/');
    });
  }

  ngOnDestroy(): void {
    this._common.showsports.next(true);
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  // Utility function to check if the user is on a mobile device
  private isMobileDevice(): boolean {
    return /Mobi|Android/i.test(navigator.userAgent);
  }

  // Create download button based on device type
  private createDownloadButton(): HTMLAnchorElement {
    const isMobile = this.isMobileDevice();
    let downloadAppButton = this.document.createElement('a');
    if (isMobile) {
      downloadAppButton.setAttribute('href', 'http://kingpin.pro/ios');
      const img = this.document.createElement('img');
      img.setAttribute('src', '/assets/img/button-7.png'); // Use relative path for assets
      img.setAttribute('alt', 'Download App for Predictions');
      downloadAppButton.appendChild(img);
    } else {
      downloadAppButton.setAttribute('href', 'https://checkout.stripe.com/c/pay/cs_live_a1Y5fN9SZ7QSryszlI7x5napojzrOiUQh1icxLN5WaHtnEU9O8uP1PLkzx');
      const img = this.document.createElement('img');
      img.setAttribute('src', '/assets/img/button-6.png'); // Use relative path for assets
      img.setAttribute('alt', 'Download App for Predictions');
      downloadAppButton.appendChild(img);
    }
    return downloadAppButton;
  }

  // Set meta tags
  private setMetadata(): void {
    this._common.updatePropertyMeta('og:type', 'article');
    this._common.setTitle(this.articleDetail.seo_title || '');
    this._common.updateMeta('author', this.articleDetail.name);
    this._common.updateMeta('twitter:data1', this.articleDetail.name);
    this._common.updateMeta('description', this.articleDetail.meta_description);
    this._common.updateMeta('keywords', this.articleDetail.meta_keywords);
    this._common.updateMeta('news_keywords', this.articleDetail.meta_keywords);
    this._common.updateMeta('image', this.articleDetail.image);
    this._common.updateMeta('twitter:image', this.articleDetail.image);
    this._common.updatePropertyMeta('og:image', this.articleDetail.image);
    this._common.updateMeta(
      'date',
      formatDate(new Date(this.articleDetail.created_at), 'dd-MM-YYYY', 'en')
    );
    this._common.updatePropertyMeta('article:published_time', this.articleDetail.created_at);
    this._common.updatePropertyMeta('article:modified_time', this.articleDetail.updated_at);
  }
}
